import EverTrue from 'app';
import BaseRouter from 'base/base-router';
import EmailRouter from './email/email-router';
import PhoneRouter from './phone/phone-router';
import BulkEmailController from './bulk-email/bulk-email-controller';
import IsFlaggedController from 'components/flags/is-flagged-controller';

class OutreachRouter extends BaseRouter {
  static initClass() {
    this.prototype.routes = {
      'outreach/email': 'email',
      'outreach/bulk-email(/)': 'bulkEmail',
      'outreach/phone': 'phone',
    };
  }

  constructor() {
    super();
    this.emailRouter = new EmailRouter();
    this.phoneRouter = new PhoneRouter();
    this.onTabChange = this.onTabChange.bind(this);
  }

  onTabChange(tab) {
    EverTrue.UrlManager.navigate(`/outreach/${tab}`, true, false);
  }

  email() {
    this.emailRouter.emailDrafts();
  }

  /**
   * Bulk Email Page - shows scheduled and sent bulk emails.
   */
  bulkEmail() {
    EverTrue.execute('setBrowserTitle', 'Your Bulk Emails');
    this.currentView = (
      <IsFlaggedController flag="signal">
        <BulkEmailController />
      </IsFlaggedController>
    );
    EverTrue.page.mount(this.currentView);
  }

  phone() {
    this.phoneRouter.phone();
  }
}

OutreachRouter.initClass();
export default OutreachRouter;
